import type { GetProductsResItem2Dto } from '@travelity/api/generated';
import { Box } from '@mui/material';
import { SidebarContent } from '@components/sidebar-content';

import { useTranslation } from 'react-i18next';

import { OnboardingClasses } from '@/onboarding';

import { PackageDetails } from './components/PackageDetails';
import { PackageSchedule } from './components/PackageSchedule';
import { PackageRoutes } from './components/PackageRoutes';
import { PackageFinancials } from './components/PackageFinancials';
import { PackageImages } from './components/PackageImages';
import { PackagePolicies } from './components/PackagePolicies';
import { PackageActivities } from './components/PackageActivities';

interface PackageSidebarProps {
    onClose: () => void;
    product: GetProductsResItem2Dto;
}

const PackageSidebar = ({ product, onClose }: PackageSidebarProps) => {
    const { t } = useTranslation('product');

    return (
        <SidebarContent
            className={OnboardingClasses.PRODUCT_PREVIEW_PANEL}
            title={t('Package Preview')}
            onClose={onClose}
        >
            <Box
                sx={{
                    '&&& .MuiAccordionSummary-root': {
                        borderBottom: '1px solid #DFE1ED',
                    },
                    '&&& .MuiAccordionDetails-root': {
                        py: 3,
                    },
                }}
            >
                <PackageDetails product={product} />
                <PackageRoutes product={product} />
                <PackageSchedule product={product} />
                <PackageFinancials product={product} />
                <PackageImages product={product} />
                <PackagePolicies product={product} />
                <PackageActivities product={product} />
            </Box>
        </SidebarContent>
    );
};

export default PackageSidebar;
